import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectIsMassSubmissionUuidExists, toggleMassSubmissionUuids } from 'state/review'
import { SubmissionState } from 'state/submissions'
import Checkbox from 'particles/Checkbox'
import styled from 'particles/themes/styled'
import { theme } from 'theme'

interface MassSubmissionCheckboxProps {
    submission: SubmissionState
}

interface StyledCheckboxProps {
    isError?: boolean
}

const StyledCheckbox = styled(Checkbox)<StyledCheckboxProps>`
    position: absolute;
    top: 14px;
    right: 14px;
    .MuiCheckbox-root {
        color: ${({ isError }) => isError && theme.colors.frenchRose};
    }
`

const MassSubmissionCheckbox: React.FC<MassSubmissionCheckboxProps> = ({ submission }) => {
    const dispatch = useDispatch()
    const isMassSubmissionSelected = useSelector(selectIsMassSubmissionUuidExists(submission.uuid))
    const toggleSelectedMassUuids = useCallback(() => {
        dispatch(toggleMassSubmissionUuids([submission.uuid]))
    }, [submission.uuid])
    const isBulkActionErr = submission && submission.error ? true : false

    return (
        <StyledCheckbox
            isError={isBulkActionErr}
            checkbox={isMassSubmissionSelected ? 'selected' : 'notSelected'}
            onChange={toggleSelectedMassUuids}
            onClick={e => e.stopPropagation()}
        />
    )
}

export default MassSubmissionCheckbox
